const AudaxConstants ={

LocalityOptions :[
    { label: "York", value: [53.958332, -1.080278] },
    { label: "Worcester, Worcestershire", value: [52.192001, -2.22] },
    { label: "Winchester, Hampshire", value: [51.063202, -1.308] },
    { label: "Wells, South West England", value: [51.209, -2.647] },
    { label: "Wakefield, West Yorkshire", value: [53.68, -1.49] },
    { label: "Truro, Cornwall", value: [50.259998, -5.051] },
    { label: "Sunderland, North East", value: [54.906101, -1.38113] },
    { label: "Sheffield, South Yorkshire", value: [53.383331, -1.466667] },
    { label: "Salford, North West", value: [53.483002, -2.2931] },
    { label: "St. Davids, Wales", value: [51.882, -5.269] },
    { label: "St.Albans, Hertfordshire", value: [51.755001, -0.336] },
    { label: "Ripon, North Yorkshire", value: [54.138, -1.524] },
    { label: "Portsmouth, Hampshire", value: [50.805832, -1.087222] },
    { label: "Perth, Scotland", value: [56.396999, -3.437] },
    { label: "Nottingham", value: [52.950001, -1.15] },
    { label: "Newry, Northern Ireland", value: [54.175999, -6.349] },
    { label: "Newcastle Upon Tyne", value: [54.966667, -1.6] },
    { label: "Liverpool", value: [53.400002, -2.983333] },
    { label: "Lincoln, Lincolnshire", value: [53.234444, -0.538611] },
    { label: "Lichfield, Staffordshire", value: [52.683498, -1.82653] },
    { label: "Leicester, the East Midlands", value: [52.633331, -1.133333] },
    { label: "Lancaster, Lancashire", value: [54.047001, -2.801] },
    { label: "Hereford, Herefordshire", value: [52.056499, -2.716] },
    { label: "Gloucester, Gloucestershire", value: [51.864445, -2.244444] },
    { label: "Glasgow", value: [55.860916, -4.251433] },
    { label: "Exeter", value: [50.716667, -3.533333] },
    { label: "Ely, Cambridgeshire", value: [52.398056, 0.262222] },
    { label: "Durham", value: [54.7761, -1.5733] },
    { label: "Dundee, Scotland", value: [56.462002, -2.9707] },
    { label: "Derry, Northern Ireland", value: [54.9958, -7.3074] },
    { label: "Derby, Derbyshire", value: [52.916668, -1.466667] },
    { label: "Coventry, West Midlands", value: [52.408054, -1.510556] },
    { label: "Chichester, West Sussex", value: [50.836498, -0.7792] },
    { label: "Chester, Cheshire", value: [53.189999, -2.89] },
    { label: "Chelmsford, Essex", value: [51.736099, 0.4798] },
    { label: "Carlisle, North West", value: [54.890999, -2.944] },
    { label: "Canterbury, Kent", value: [51.279999, 1.08] },
    { label: "Cambridge, Cambridgeshire", value: [52.205276, 0.119167] },
    { label: "Brighton & Hove, East Sussex", value: [50.827778, -0.152778] },
    { label: "Bradford, West Yorkshire", value: [53.799999, -1.75] },
    { label: "Bath, Somerset", value: [51.380001, -2.36] },
    { label: "Peterborough, Cambridgeshire", value: [52.573921, -0.25083] },
    { label: "Elgin, Scotland", value: [57.653484, -3.335724] },
    { label: "Stoke-on-Trent, Staffordshire", value: [53.002666, -2.179404] },
    { label: "Solihull, Birmingham", value: [52.412811, -1.778197] },
    { label: "Cardiff, Wales", value: [51.481583, -3.17909] },
    { label: "Eastbourne, East Sussex", value: [50.768036, 0.290472] },
    { label: "Oxford", value: [51.752022, -1.257677] },
    { label: "London", value: [51.509865, -0.118092] },
    { label: "Swindon, Swindon", value: [51.568535, -1.772232] },
    { label: "Gravesend, Kent", value: [51.441883, 0.370759] },
    { label: "Northampton, Northamptonshire", value: [52.240479, -0.902656] },
    { label: "Rugby, Warwickshire", value: [52.370876, -1.265032] },
    { label: "Sutton Coldfield, West Midlands", value: [52.570385, -1.824042] },
    { label: "Harlow, Essex", value: [51.772938, 0.10231] },
    { label: "Aberdeen", value: [57.149651, -2.099075] },
    { label: "Swansea", value: [51.621441, -3.943646] },
    { label: "Chesterfield, Derbyshire", value: [53.235046, -1.421629] },
    { label: "Lisburn, Ireland", value: [54.50972, -6.0374] },
    { label: "Londonderry, Derry", value: [55.006763, -7.318268] },
    { label: "Salisbury, Wiltshire", value: [51.068787, -1.794472] },
    { label: "Manchester", value: [53.483959, -2.244644] },
    { label: "Bristol", value: [51.454514, -2.58791] },
    { label: "Wolverhampton, West Midlands", value: [52.59137, -2.110748] },
    { label: "Preston, Lancashire", value: [53.765762, -2.692337] },
    { label: "Ayr, South Ayrshire", value: [55.458565, -4.629179] },
    { label: "Hastings, East Sussex", value: [50.854259, 0.573453] },
    { label: "Bedford", value: [52.136436, -0.460739] },
    { label: "Basildon, Essex", value: [51.572376, 0.470009] },
    { label: "Chippenham, Wiltshire", value: [51.458057, -2.116074] },
    { label: "Birmingham, West Midlands", value: [52.489471, -1.898575] },
    { label: "Folkestone, Kent", value: [51.081398, 1.169456] },
    { label: "Edinburgh, Scotland", value: [55.953251, -3.188267] },
    { label: "Southampton", value: [50.909698, -1.404351] },
    { label: "Belfast, Northern Ireland", value: [54.607868, -5.926437] },
    { label: "Uckfield, East Sussex", value: [50.967941, 0.085831] },
    { label: "Worthing, West Sussex", value: [50.825024, -0.383835] },
    { label: "Leeds, West Yorkshire", value: [53.801277, -1.548567] },
    { label: "Hull", value: [53.76775, -0.335827] },
    { label: "Plymouth", value: [50.376289, -4.143841] },
    { label: "Inverness", value: [57.477772, -4.224721] },

  ] 
}

export default AudaxConstants; 